export default __webpack_public_path__ + "static/mechen-e01237622a85a67d4d9d4703c84f55a9.jpg";